import { useFetcher } from 'react-router-dom'
import { type Project } from 'api-client'

import { CLEAR_QRYN_CACHE } from '~/entities/integrations/qryn'

import { Button } from '~/components/Button'
import { Message } from '~/components/Message'
import { Stack } from '~/components/Stack'

type ClearQrynCacheProps = {
  projectSlug: Project['slug']
}

export function ClearQrynCache({ projectSlug }: ClearQrynCacheProps) {
  const fetcher = useFetcher()

  return (
    <Stack space="small">
      <Message type="warning" size="small">
        This option removes all cached query results for this project. The next run of each query
        is computed from scratch and repopulates the cache.
      </Message>
      <fetcher.Form method="post" action={`/${projectSlug}/stack/qryn`}>
        <Button
          type="submit"
          color="brand"
          name="intent"
          value={CLEAR_QRYN_CACHE}
          isDisabled={fetcher.state !== 'idle'}
        >
          Clear cache
        </Button>
      </fetcher.Form>
    </Stack>
  )
}
